import { ButtonGroup } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { IsSuperAdmin } from 'shared/permissions/IsSuperAdmin';
import { useIsSupplier } from 'shared/permissions/useIsSupplier';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { contractsApi } from '../api/contracts.api';
import ImportFileUploader from 'components/ui/file-uploader/ImportFileUploader';
import { ContractLinesAllColumns } from '../contract-lines-all';

export const Contracts = () => {
  const translationPrefix = 'pages.contract.list';
  const { t } = useTranslation();

  const datagridRefresh = useRef(null);
  const isSupplierRole = useIsSupplier();

  const columns: GridColDef[] = ContractLinesAllColumns(contractsApi.services.contractService);

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        pageType="contracts"
        menuRight={
          <div className="flex justify-end items-center">
            <AddEnhancedButton prefix={translationPrefix} to="new" requireTenantAdmin />
            <ButtonGroup>
              <IsSuperAdmin>
                <ImportFileUploader
                  service={contractsApi.services.contractService}
                  importMethod={contractsApi.services.contractService.importAggregatedLinesFromFile}
                  templateGetterMethod={
                    contractsApi.services.contractService.getAggregatedImportTemplate
                  }
                />
              </IsSuperAdmin>
            </ButtonGroup>
          </div>
        }>
        <div className="mt-6">
          <EnhancedDataGrid
            columns={columns}
            service={contractsApi.services.contractService}
            refresh={datagridRefresh}
            disableEdit={!isSupplierRole}
            disableExport={true}
          />
        </div>
      </TenantPage>
    </>
  );
};

export default Contracts;
